// extracted by mini-css-extract-plugin
module.exports = {"textOverflow":"style_textOverflow__3jhqW","textWrap":"style_textWrap__2CDEs","divider":"style_divider__12fO1"};